import { z } from 'zod'

export const BillDataSchema = z.object({
  recordId: z.string(),
  roomNumber: z.string().min(1),
  contractId: z.string().uuid().nullable(),

  // Displayed date range (derived from record_date)
  startDateEN: z.string(),
  endDateEN: z.string(),
  periodLabel: z.string(),

  // Room fees
  rent: z.number(),
  maintenanceFee: z.number(),
  internet: z.number(),
  furniture: z.number(),
  fee: z.number(),
  otherFeeLabel: z.string(),

  // Water meter
  waterPrev: z.number(),
  waterNow: z.number(),
  waterUnits: z.number(),
  waterUnitPrice: z.number(),
  waterTotal: z.number(),

  // Electricity meter
  elecPrev: z.number(),
  elecNow: z.number(),
  elecUnits: z.number(),
  elecUnitPrice: z.number(),
  electricTotal: z.number(),

  // Computed grand total
  total: z.number(),

  paymentStatus: z.enum(['paid', 'unpaid']),

  // Tenant info
  tenantFirstName: z.string().nullable(),
  tenantLastName: z.string().nullable(),
  tenantPhone: z.string().nullable(),

  // Payment QR code
  qrUrl: z.string(),

  // Logo
  logoUrl: z.string(),
})

export type BillData = z.infer<typeof BillDataSchema>
